import { fetcher } from "helpers/fetcher";

import { TGetCountryRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getCountry = async () => {
  return await fetcher<TGetCountryRes, any>(ENDPOINT.USER.GET_COUNTRY, {
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.GET_COUNTRY.version,
    },
  });
};

export const queryGetCountry = async () => {
  return (await getCountry()).data;
};

queryGetCountry._key = [ENDPOINT.USER.GET_COUNTRY.url];
